(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-chart-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  // Get the modal
  var modal = document.getElementById("sizeChartModal");

  // Get the button that opens the modal
  var btn = document.getElementById("openSizeChartBtn");

  // Get the <span> element that closes the modal
  var span = document.getElementsByClassName("size-chart-modal-close")[0];

  // When the user clicks the button, open the modal 
  if (btn) {
    btn.onclick = function() {
      modal.style.display = "block";
    }
  }

  // When the user clicks on <span> (x), close the modal
  if (span) {
    span.onclick = function() {
      modal.style.display = "none";
    }
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }
});
  } catch(e) { console.error(e); }
})();

})();
